import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin, Card, Typography, Alert, Input, Button } from 'antd';
import {
  getQuestionnairesAction,
  updateQuestionnaireAction,
} from '../../../../../store/actions/questionnaire.action';

const { Text, Title } = Typography;
const { TextArea } = Input;

const QuestionnaireEmbed = ({ condition_id }) => {
  const dispatch = useDispatch();
  const { questionnaireList, questionnaireLoading, questionnaireError } =
    useSelector((state) => state.questionnaireState);
  const [questionsText, setQuestionsText] = useState('');

  useEffect(() => {
    if (condition_id) {
      console.log('condition_id', condition_id);
      dispatch(getQuestionnairesAction(condition_id));
    }
  }, [dispatch, condition_id]);

  const displayItem =
    questionnaireList && questionnaireList.length > 0
      ? questionnaireList[0]
      : null;

  useEffect(() => {
    if (displayItem) {
      setQuestionsText(displayItem.questions);
    }
  }, [displayItem]);

  const handleSave = () => {
    if (!displayItem) return;

    const payload = {
      condition_id: displayItem.condition_id,
      questions: questionsText.trim(),
    };

    dispatch(
      updateQuestionnaireAction(displayItem.questionnaire_id, payload, () => {
        // Optionally refresh data or show success message
        dispatch(getQuestionnairesAction(condition_id));
      })
    );
  };

  if (questionnaireLoading) {
    return <Spin />;
  }

  if (questionnaireError) {
    return (
      <Alert message="Error loading questionnaire" type="error" showIcon />
    );
  }

  if (!displayItem) {
    return (
      <Alert
        description="No questionnaire found for this condition."
        type="info"
        showIcon
      />
    );
  }

  return (
    <>
      <Alert
        message="You can use {{questions}} in the prompt template to substitute these questions."
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
      />
      <TextArea
        value={questionsText}
        onChange={(e) => setQuestionsText(e.target.value)}
        placeholder="Enter all your questions here"
        autoSize={{ minRows: 10, maxRows: 20 }}
        style={{ width: '100%', marginBottom: '16px' }}
      />
      <div style={{ textAlign: 'right' }}>
        <Button
          type="primary"
          onClick={handleSave}
          disabled={
            !questionsText.trim() || questionsText === displayItem.questions
          }
          loading={questionnaireLoading}
        >
          Save Changes
        </Button>
      </div>
    </>
  );
};

export default QuestionnaireEmbed;
